module.exports = __webpack_public_path__ + "img/Da-Reg.20656a14.svg";